/**
 * Check if a user is the owner of a project
 * @param {Object} project - The project object
 * @param {Object} currentUser - The current user object
 * @returns {boolean} Whether the user is the project owner
 */
export function isProjectOwner(project, currentUser) {
  if (!project || !currentUser) {
    return false;
  }
  
  // Check both possible owner ID locations
  const projectOwnerId = project.user_id || project.owner?.id;
  
  return projectOwnerId && projectOwnerId === currentUser.id;
}

/**
 * Check if a project is archived
 * @param {Object} project - The project object
 * @returns {boolean} - Returns true if the project is archived
 */
export function isProjectArchived(project) {
  if (!project) return false;
  return project.archived === true || project.status === 'archived';
}